import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=537b00f2&scoped=true"
import script from "./PostPreview.vue?vue&type=script&lang=js"
export * from "./PostPreview.vue?vue&type=script&lang=js"
import style0 from "./PostPreview.vue?vue&type=style&index=0&id=537b00f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b00f2",
  null
  
)

export default component.exports